<template v-if="isAdmin">
  <div class="hello">
    <v-card color="transparent" flat>
      <v-item-group>
        <v-container>
          <v-row>
            <Widget
              v-if="stats != 0"
              :stat="_.filter(stats, { id: 'bailleurs' })[0]"
              subTitle="Bailleurs"
              icon="mdi-cube "
              color="blue"
              route="/organisation/bailleurs"
            />
            <Widget
              v-if="stats != 0"
              :stat="_.filter(stats, { id: 'projets' })[0]"
              subTitle="Projets"
              icon="mdi-content-copy"
              color="orange darken-2"
              route="/organisation/bailleurs"
            />
            <Widget
              v-if="stats != 0"
              :stat="_.filter(stats, { id: 'groupes' })[0]"
              subTitle="Groupes"
              icon="mdi-home-group"
              color="green darken-2"
              route="/groupes"
            />
          </v-row>
        </v-container>
      </v-item-group>
    </v-card>

    <!--   <template>
      <v-card class="mx-4">
        <v-card-title>Formations 2020</v-card-title>
        <v-card-text justify="center" align="center">
          <apexchart type="bar" :options="options" :series="series">
          </apexchart>
        </v-card-text>
      </v-card>
    </template> -->
    <!--   <v-item-group>
      <v-container>
        <v-row>
          <v-card
            ><v-card-text>
              <v-tabs v-model="tab" align-with-title>
                <v-tab href="#campagne"> Campagne</v-tab>
                <v-tab href="#formation1"> Formation de groupe</v-tab>
                <v-tabs-items v-model="tab">
                  <v-tab-item value="campagne">Campagne </v-tab-item>
                  <v-tab-item value="formation1"
                    >Formation de groupe
                  </v-tab-item></v-tabs-items
                >
              </v-tabs>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container></v-item-group
    > -->

    <v-card class="mx-16">
      <v-card-title Statistiques>
        Statistiques globales
      </v-card-title>
      <v-card-text>
        <v-tabs v-model="activeTab">
          <v-tab v-for="item in tabs" :key="item.tab">
            {{ item.tab }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item v-for="item in tabs" :key="item.tab">
            <component :is="item.content" />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>

    <Navigation :elements="AdminNavigation" v-if="user.isAdmin" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      tab: "campagne",
      options: {
        chart: {
          id: "vuechart-example",
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          categories: [
            "Jan",
            "Fév",
            "Mar",
            "Avr",
            "Mai",
            "Jui",
            "Juil",
            "Aou",
            "Sep",
            "Oct",
            "Nov",
            "Déc",
          ],
        },

        title: {
          text: "Formations 2020",
          align: "center",
          style: {
            fontSize: "20px",
          },
        },
        colors: ["#009933"],
      },

      series: [
        {
          name: "Formations",
          data: [55, 62, 89, 66, 98, 72, 101, 75, 94, 120, 117, 139],
        },
      ],
      activeTab: "membres",
      tabs: [
          { tab: "membres", content: "membres" },
      /*   { tab: "menages", content: "menages" }, */
        { tab: "groupes", content: "groupes" },
      ],
    };
  },
  components: {
    Widget: require("@/components/Widget.vue").default,
    Navigation: require("@/components/Navigation.vue").default,
    membres: require("@/components/stats/membres.vue").default,
    menages: require("@/components/stats/menages.vue").default,
    groupes: require("@/components/stats/groupes.vue").default,
  },
  created() {
    if (!this.isAdmin) {
      this.$router.push("/");
    }
    this.GetAllCounts();
    this.GetAllGroupeRequest();
    this.GetAllTypeDetails();
    this.GetAllRolesHorsGroupe();
    this.GetRegions();
    this.GetProvinces();
  },
  mounted() {
    //console.clear();
  },
  computed: {
    ...mapState({
      isAdmin: (state) => state.Auth.isAdmin,
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
      groupesRequest: (state) => state.Groupes.groupesRequest,
      stats: (state) => state.Counts.Counts,
      user: (state) => state.Auth.user,
      Regions: (state) => state.Regions.Regions,
      Projets: (state) => state.Projets.projets,
    }),
  },
  methods: {
    ...mapActions({
      getBailleurs: "Bailleurs/getListeBailleurs",
      getProjets: "Projets/getListeProjets",
      GetAllGroupeRequest: "Groupes/GetAllGroupeRequest",
      GetAllCounts: "Counts/GetAll",
      GetAllTypeDetails: "TypeDetailEtape/GetAll",
      GetAllRolesHorsGroupe: "RolesHorsGroupe/GetAll",
      GetRegions: "Regions/GetAll",
      GetProvinces: "Provinces/GetAll",
    }),
  },
};
</script>

<style scoped>
.tiles:before {
  content: "";
  float: left;
  padding-top: 100%;
}

.square {
  height: 100%;
  width: 100%;
  margin: 0;
}
</style>
